const data = {
    meta : {
        title       : "Team - Developer Software, Website dan Aplikasi Mobile Terbaik di Makassar",
        description : "Mari mengenal dekat para pakar dibidangnya masing – masing, yang siap membantu menyelesaikan masalah anda dengan pendekatan kreatif dan inovatif.",
        imageUrl    : "/images/preview.png",
        imageAlt    : "/images/preview.png"
    },
    banner : {
        id : {
            title : "Kenali Para Ahli",
            subTitle : "Mari mengenal dekat para pakar dibidangnya masing – masing, yang siap membantu menyelesaikan masalah anda dengan pendekatan kreatif dan inovatif."
        }
    },
}

export default data